import { render, staticRenderFns } from "./DamagePanel.vue?vue&type=template&id=9d2c398a&scoped=true&"
import script from "./DamagePanel.vue?vue&type=script&lang=js&"
export * from "./DamagePanel.vue?vue&type=script&lang=js&"
import style0 from "./DamagePanel.vue?vue&type=style&index=0&id=9d2c398a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d2c398a",
  null
  
)

export default component.exports